import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Task} from '@extensions/task'
import {useTaskDescription} from '../task-description-store'
import {TopPanelButtons} from './top-panel-buttons'
import {TopPanelIcons} from './top-panel-icons'

const TwTopPanelContainer = tw.div<{$fullscreen?: boolean; $newBg?: boolean}>`
  pt-20
  pb-20
  mx-auto
  ${p => {
    if (p.$fullscreen) {
      return `px-24 absolute z-1000 right-0`
    }

    const cx: string[] = []
    cx.push(p.$newBg ? 'bg-background-primary' : 'bg-main-old')
    cx.push(`pr-8 pl-24 border-0 border-b-1 border-split-old border-solid`)

    return cx.join(' ')
  }}
  ${p => (p.$newBg ? '' : '')}
`

const TwTopPanelContent = tw.div<{$fullscreen?: boolean}>`
  flex
  items-center
  h-24
  gap-8
  leading-6
  text-14
  ${p => p.$fullscreen && `font-semibold w-max`}
`

export const TopPanel = observer(({newBg}: {newBg?: boolean}) => {
  const [state, store] = useTaskDescription()

  return (
    <div style={state.fullscreen ? {width: 'calc(100% - 10px)'} : {}}>
      <TwTopPanelContainer $fullscreen={state.fullscreen} $newBg={newBg}>
        <TwTopPanelContent $fullscreen={state.fullscreen}>
          <TopPanelButtons />
          {!Task.isTaskTemplate(store.taskHub) && <TopPanelIcons />}
        </TwTopPanelContent>
      </TwTopPanelContainer>
    </div>
  )
})
